import { ReportListItemData } from './report-base';

export class RefundReportData extends ReportListItemData {
  paymentID: number;
  maskedccnum: string;
  cardtype: string;
  dateRefund: Date;
  amountRefund: number;
  clubuserrefundID: number;
  reason: string;
}

export class RefundReport {
  totalNumberOfRefund: number;
  totalRefundAmount: number;
  list: RefundReportData;

  constructor(data: any = {}) {
    this.totalNumberOfRefund = +data.totalNumberOfRefund;
    this.totalRefundAmount = +data.totalRefundAmount;
    this.list = data.refundReportUserList ? data.refundReportUserList.map(l => new RefundReportData(l)) : [];
  }
}



// WEBPACK FOOTER //
// ./src/app/models/reports/refund-report.ts